import { jsx as _jsx } from "react/jsx-runtime";
import { extendCommonContentStylesheet } from "@devowl-wp/web-cookie-banner";
import { useStylesheet } from "../../../contexts";
const FooterLink = (param)=>{
    let { children, ...anchorRest } = param;
    const { FooterLink } = useStylesheet().extend(...extendCommonContentStylesheet);
    return /*#__PURE__*/ _jsx(FooterLink, {
        ...anchorRest,
        children: children
    });
};
export { FooterLink };
